export { default as ShowWhenHotelsTabSelected } from './ShowWhenHotelsTabSelected';
